module.exports = "<div data-ng-message=maxLength>The media name is too long</div> <div data-ng-message=required>A name is required</div> ";